export default __webpack_public_path__ + "static/media/12.8f593edf.png";